/* Inlined into the downloaded embedded checkout asset; no payment or server events. */
function createEmbeddedTikTokFunnel(w, d, config) {
  "use strict";
  var rawFetch = w.fetch && w.fetch.bind(w);
  var pixels = [], ready = null, sequence = 0, seenCheckout = {}, installed = false;
  function enabled() {
    return config().tiktokFunnelTracking !== false && config().tiktokFunnelConsent !== false;
  }
  function sdk(id) {
    var q = w.ttq;
    if (!q) {
      w.TiktokAnalyticsObject = "ttq";
      q = w.ttq = [];
      q._i = {}; q._t = {}; q._o = {};
      var methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie", "holdConsent", "revokeConsent", "grantConsent"];
      function defer(target, name) { target[name] = function () { target.push([name].concat(Array.prototype.slice.call(arguments))); }; }
      methods.forEach(function (name) { defer(q, name); });
      q.instance = function (key) { return q._i[key]; };
      q.load = function (key) {
        var instance = q._i[key] = [];
        methods.forEach(function (name) { defer(instance, name); });
        q._t[key] = Date.now(); q._o[key] = {};
        var script = d.createElement("script"); script.async = true;
        script.src = "https://analytics.tiktok.com/i18n/pixel/events.js?sdkid=" + encodeURIComponent(key) + "&lib=ttq";
        instance._u = "https://analytics.tiktok.com/i18n/pixel/events.js";
        d.head.appendChild(script);
      };
    }
    if ((!q._i || !q._i[id]) && typeof q.load === "function") q.load(id);
    return q.instance && q.instance(id);
  }
  function preload() {
    if (!enabled() || !rawFetch) return Promise.resolve([]);
    if (ready) return ready;
    var endpoint = "https://safespay.app/api/public/asite-tracking?shop=" + encodeURIComponent(w.location.hostname);
    ready = rawFetch(endpoint, { credentials: "omit", mode: "cors", signal: AbortSignal.timeout(4000) })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!enabled() || !data || !data.matched) return [];
        pixels = (data.tiktokPixels || []).map(function (p) { return String(p.pixelId || "").trim(); })
          .filter(function (id, i, all) { return /^[A-Za-z0-9_-]{5,100}$/.test(id) && all.indexOf(id) === i; });
        pixels.forEach(sdk); return pixels;
      }).catch(function () { return []; });
    return ready;
  }
  function properties(items, currency) {
    if (!Array.isArray(items) || !items.length || !/^[A-Z]{3}$/.test(currency || "")) return null;
    var contents = items.map(function (item) {
      return { content_id: String(item.variant_id || item.id || item.vid || ""), content_name: String(item.product_title || item.title || ""),
        quantity: Number(item.quantity != null ? item.quantity : item.qty),
        price: Number(item.final_price != null ? item.final_price : item.price) / 100 };
    });
    if (contents.some(function (i) { return !i.content_id || !Number.isInteger(i.quantity) || i.quantity < 1 || !Number.isFinite(i.price) || i.price < 0; })) return null;
    return { contents: contents, content_type: "product", currency: currency,
      value: contents.reduce(function (sum, i) { return sum + Math.round(i.price * 100) * i.quantity; }, 0) / 100 };
  }
  function emit(name, props, id) {
    if (!enabled() || !props) return Promise.resolve();
    function dispatch() {
      if (!enabled()) return;
      pixels.forEach(function (pixel) {
        try { var instance = sdk(pixel); if (instance && instance.track) instance.track(name, props, { event_id: id }); } catch (e) {}
      });
    }
    if (pixels.length) { dispatch(); return Promise.resolve(); }
    return preload().then(dispatch).catch(function () {});
  }
  function addQuantities(body) {
    try {
      if (typeof body === "string") {
        try { return addQuantities(JSON.parse(body)); }
        catch (e) { body = new URLSearchParams(body); }
      }
      if (body && typeof body.get === "function") {
        var indexed = {};
        if (typeof body.forEach === "function") body.forEach(function (value, name) {
          var match = /^items\[(\d+)\]\[(id|quantity)\]$/.exec(name);
          if (!match) return;
          var item = indexed[match[1]] || (indexed[match[1]] = {});
          item[match[2]] = String(value);
        });
        var indices = Object.keys(indexed).sort(function (a, b) { return Number(a) - Number(b); });
        if (indices.length) return indices.map(function (index) {
          var item = indexed[index];
          return { id: String(item.id || ""), quantity: Number(item.quantity == null || item.quantity === "" ? 1 : item.quantity) };
        });
        var quantity = body.get("quantity");
        return [{ id: String(body.get("id") || ""), quantity: Number(quantity == null || quantity === "" ? 1 : quantity) }];
      }
      if (body && Array.isArray(body.items)) return body.items;
      return body ? [{ id: String(body.id || ""), quantity: Number(body.quantity == null ? 1 : body.quantity) }] : [];
    } catch (e) { return []; }
  }
  function safesTikTokAddedItems(data, requested) {
    var rows = data && (Array.isArray(data.items) ? data.items : [data]);
    if (!rows || !rows.length || !Array.isArray(requested) || !requested.length) return null;
    var quantities = Object.create(null), found = Object.create(null), result = [];
    for (var i = 0; i < requested.length; i++) {
      var request = requested[i] || {};
      var id = String(request.variant_id || request.id || request.vid || "");
      var quantity = Number(request.quantity == null ? 1 : request.quantity);
      if (!id || !Number.isInteger(quantity) || quantity < 1) return null;
      quantities[id] = (quantities[id] || 0) + quantity;
    }
    for (var j = 0; j < rows.length; j++) {
      var row = rows[j] || {};
      var rowId = String(row.variant_id || row.id || "");
      if (!quantities[rowId]) continue;
      var price = Number(row.final_price != null ? row.final_price : row.price);
      if (!Number.isFinite(price) || price < 0) return null;
      if (found[rowId]) {
        // Different prices for one variant cannot be allocated from a cumulative response safely.
        if (found[rowId].price !== price) return null;
        continue;
      }
      found[rowId] = { price: price };
      result.push(Object.assign({}, row, { quantity: quantities[rowId] }));
    }
    if (Object.keys(found).length !== Object.keys(quantities).length) return null;
    return result.length ? result : null;
  }

  function added(data, quantities) {
      var items = safesTikTokAddedItems(data, quantities);
      if (!items) return;
      var currency = w.Shopify && w.Shopify.currency && w.Shopify.currency.active;
      emit("AddToCart", properties(items, currency), "safes_add_" + Date.now() + "_" + (++sequence));
    }
  function isAdd(input, method) {
    try {
      var url = new URL(typeof input === "string" ? input : input.url, w.location.origin);
      return url.origin === w.location.origin && /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/cart\/add(?:\.js)?\/?$/i.test(url.pathname) && String(method || "GET").toUpperCase() === "POST";
    } catch (e) { return false; }
  }
  function install() {
    if (!enabled() || installed) return;
    installed = true;
    preload();
    if (rawFetch) {
      var original = w.fetch;
      w.fetch = function (input, options) {
        var matches = isAdd(input, options && options.method || input && input.method);
        if (matches) {
          var quantities;
          try { quantities = options && options.body != null ? Promise.resolve(addQuantities(options.body)) : input && input.clone ? input.clone().text().then(addQuantities) : Promise.resolve([]); }
          catch (e) { quantities = Promise.resolve([]); }
        }
        var result = original.apply(this, arguments);
        if (matches) {
          // Clone only; never consume or replace the response returned to the theme.
          result.then(function (response) {
            if (response.ok) Promise.all([response.clone().json(), quantities]).then(function (parts) { added(parts[0], parts[1]); }).catch(function () {});
          }).catch(function () {});
        }
        return result;
      };
    }
    var proto = w.XMLHttpRequest && w.XMLHttpRequest.prototype;
    if (proto) {
      var open = proto.open, send = proto.send, requests = new WeakMap();
      proto.open = function (method, url) { var result = open.apply(this, arguments); requests.set(this, isAdd(String(url), method)); return result; };
      proto.send = function () {
        var xhr = this;
        var quantities = addQuantities(arguments[0]);
        if (requests.get(xhr)) xhr.addEventListener("loadend", function () {
          if (xhr.status < 200 || xhr.status >= 300) return;
          try { added(xhr.responseType === "json" ? xhr.response : JSON.parse(xhr.responseText), quantities); } catch (e) {}
        }, { once: true });
        return send.apply(this, arguments);
      };
    }
  }
  function checkout(url) {
    try {
      if (!enabled() || seenCheckout[url]) return;
      var target = new URL(url, w.location.origin);
      var settings = config();
      var configuredPaths = [settings.proxyPath, settings.wrapperPath].filter(function (path) { return typeof path === "string" && path.charAt(0) === "/"; });
      if (target.origin !== w.location.origin || (!/^\/a\/checkouts\//.test(target.pathname) && configuredPaths.indexOf(target.pathname) < 0)) return;
      var raw = target.searchParams.get("payload") || "";
      var payload = JSON.parse(decodeURIComponent(escape(w.atob(raw.replace(/-/g, "+").replace(/_/g, "/")))));
      var props = properties(payload.i, payload.c);
      if (!props) return;
      seenCheckout[url] = true;
      // Initiation means a valid checkout redirect, not proof that the payment page loaded.
      emit("InitiateCheckout", props, "safes_checkout_" + Date.now() + "_" + (++sequence));
    } catch (e) {}
  }
  return { install: install, checkout: checkout };
}
